import Consumption from '../../../../base/forms/airdome/consumption';

const consumption: Consumption = {
  start: 'Starten',
  end: 'Ende'
};

export default consumption;
